import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { messageSequenceActions } from ".";
import {
  FETCH_SEQUENCE_LIST_PROGRESS,
  FETCH_SEQUENCE_LIST_SUCCESS,
  FETCH_SEQUENCE_LIST_FAILED,
  FETCH_SEQUENCE_STEPS_PROGRESS,
  FETCH_SEQUENCE_STEPS_SUCCESS,
  FETCH_SEQUENCE_STEPS_FAILED,
  CLEAR_SEQUENCE_STATE,
} from "./MessageSequencesActions";
import { initialMessageSequenceState } from "./defaultState";
import { IMessageSequencesState } from "./MessageSequence.types";

export const messageSequenceReducer = (
  state: IStoreState["messageSequence"] = initialMessageSequenceState,
  action: messageSequenceActions,
) => {
  switch (action.type) {
    case FETCH_SEQUENCE_LIST_PROGRESS:
      return produce(state, (draft: IMessageSequencesState) => {
        draft.list.loading = LoadState.InProgress;
      });

    case FETCH_SEQUENCE_LIST_SUCCESS:
      return produce(state, (draft: IMessageSequencesState) => {
        draft.list.loading = LoadState.Loaded;
        draft.list.data = action.payload.data;
        draft.list.totalRecords = action.payload.totalRecords;
      });

    case FETCH_SEQUENCE_LIST_FAILED:
      return produce(state, (draft: IMessageSequencesState) => {
        draft.list.loading = LoadState.Failed;
      });

    case FETCH_SEQUENCE_STEPS_PROGRESS:
      return produce(state, (draft: IMessageSequencesState) => {
        draft.steps.loading = LoadState.InProgress;
      });

    case FETCH_SEQUENCE_STEPS_SUCCESS:
      return produce(state, (draft: IMessageSequencesState) => {
        draft.steps.loading = LoadState.Loaded;
        draft.steps.data = action.payload.data;
        draft.steps.totalRecords = action.payload.totalRecords;
      });

    case FETCH_SEQUENCE_STEPS_FAILED:
      return produce(state, (draft: IMessageSequencesState) => {
        draft.steps.loading = LoadState.Failed;
      });

    case CLEAR_SEQUENCE_STATE:
      return initialMessageSequenceState;

    default:
      return state;
  }
};
